import { useEffect, useState } from "react";
import getAPIData from "../../utils/getAPIData";
import SessionHistoryEntry from "./SessionHistoryEntry";
import PageHeader from "../shared/PageHeader";
import { Spinner, Container, Row, Col, Form, Pagination } from "react-bootstrap";
import LoadingOverlay from 'react-loading-overlay-ts';
import UnavailablePage from "./ServerUnavailablePage";
import styles from './SessionHistory.module.css';

const SessionHistory = ({ enums, lists }) => {
  const [history, setHistory] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [paginators, setPaginators] = useState([])
  const [curPage, setCurPage] = useState(1)
  // TODO: this feels really inefficient computing-wise but timewise tonight saves me headache
  const [showErrorPage, setShowErrorPage] = useState(false);
  const [showSpinner, setShowSpinner] = useState(true);
  const [showMiniSpinner, setShowMiniSpinner] = useState(false);
  const [filter, setFilter] = useState('league-only');
  const [sortOptionSelected,setSortOptionSelected] = useState('dateDesc')

  function handleFilters(e){
    setCurPage(1)
    setFilter(e.currentTarget.value)
  }
  function handleSort(e){
    setSortOptionSelected(e.currentTarget.value)
  }
  // Replace the renderPaginator function with:
  function renderPaginator() {
    const rows = [];
    const maxVisible = 5;
    let startPage = Math.max(1, curPage - Math.floor(maxVisible / 2));
    let endPage = Math.min(pageCount, startPage + maxVisible - 1);

    // Adjust start if we're near the end
    if (endPage - startPage + 1 < maxVisible) {
      startPage = Math.max(1, endPage - maxVisible + 1);
    }

    // First page
    if (startPage > 1) {
      rows.push(
        <Pagination.First key="first" onClick={() => setCurPage(1)} />,
        <Pagination.Prev 
          key="prev" 
          onClick={() => setCurPage(p => Math.max(1, p - 1))}
        />
      );
      if (startPage > 2) {
        rows.push(<Pagination.Ellipsis key="ellipsis1" disabled />);
      }
    }

    // Page numbers
    for (let i = startPage; i <= endPage; i++) {
      rows.push(
        <Pagination.Item 
          key={i} 
          active={i === curPage}
          onClick={() => setCurPage(i)}
        >
          {i}
        </Pagination.Item>
      );
    }

    // Last page
    if (endPage < pageCount) {
      if (endPage < pageCount - 1) {
        rows.push(<Pagination.Ellipsis key="ellipsis2" disabled />);
      }
      rows.push(
        <Pagination.Next 
          key="next" 
          onClick={() => setCurPage(p => Math.min(pageCount, p + 1))}
        />,
        <Pagination.Last key="last" onClick={() => setCurPage(pageCount)} />
      );
    }

    setPaginators(rows);
  }
  function fetchCurrentPage(){
    setShowMiniSpinner(true)
    getAPIData("/api/batchupload/sms_stats_data/?page=" + curPage + "&filter=" + filter + "&sort=" + (sortOptionSelected === "dateAsc" ? "asc" : "desc"))
    .then((res) => {
      if (res) {
        setShowErrorPage(false);
        setHistory([...res.data]);
        setPageCount(parseInt(res.pages));
        setShowMiniSpinner(false);
        setShowSpinner(false);
      }
    })
    .catch((err) => {
      console.error(err);
      setShowErrorPage(true);
      setShowSpinner(false);
    });
  }

  useEffect(() => {
    fetchCurrentPage();
    // eslint-disable-next-line
  },[curPage,filter,sortOptionSelected])

  useEffect(() => {
    renderPaginator();
    // eslint-disable-next-line
  },[pageCount,curPage])

  return (
    <Container>
      <PageHeader 
        title="Race History" 
        subtitle="All of our weekly Automobilista 2 races."
        />
      {showSpinner ? (

                <div className="text-center mt-4" style={{ color: 'var(--color-text)' }}>
                    <Spinner animation="border" role="status"/>
                      <div>
                        One moment please...
                      </div>
                </div>
            ) : 
            (
              <>
                <details className={styles.filterToggle}>
                  <summary>Filters</summary>
                  <div className={styles.filterRowInner}>
                    <Form.Group>
                      <Form.Label className="mb-2">Order By:</Form.Label>
                      <Form.Select value={sortOptionSelected} onChange={handleSort}>
                        <option value="dateDesc">Date Descending</option>
                        <option value="dateAsc">Date Ascending</option>
                      </Form.Select>
                    </Form.Group>
                    <Form.Group>
                      <Form.Label className="mb-2">Filter By:</Form.Label>
                      <Form.Select value={filter} onChange={handleFilters}>
                        <option value="all">All Races</option>
                        <option value="league-only">League Races</option>
                      </Form.Select>
                    </Form.Group>
                  </div>
                </details>
                {/* History List */}
                <LoadingOverlay
                  active={showMiniSpinner}
                  spinner
                  text='Loading...'>  
                  <Row className="motion-stagger">
                    {
                      history
                      .map((h, i) => 
                        <SessionHistoryEntry key={i} data={h} enums={enums} lists={lists} showLeagueInfo={true}/>
                      ) 
                    }
                  
                  </Row>
                </LoadingOverlay>
                <Row>
                  <Col></Col>
                  <Col className="justify-content-md-center display-flex">
                  <Pagination className="justify-content-center my-4">
                    {paginators}
                  </Pagination>
                  </Col>
                  <Col></Col>
                </Row>
              </>
            )
      }
      {
        showErrorPage && <UnavailablePage/>
      }
    </Container>
  );
};
export default SessionHistory;
